import { Mail } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const MiniEmailIllustration = () => {
  const { t } = useLanguage();
  return (
        <div className="relative w-full mx-auto">
      {/* Email Interface */}
      <div className="bg-card rounded-lg shadow-lg border border-border p-4 space-y-3">
        {/* Header */}
        <div className="flex items-center gap-2 pb-3 border-b border-border">
          <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
            <Mail className="w-4 h-4 text-primary" />
          </div>
          <div>
            <div className="text-sm font-semibold">{t.miniIllustrations.email.header}</div>
            <div className="text-xs text-muted-foreground">{t.miniIllustrations.email.newCount}</div>
          </div>
        </div>

        {/* Email Items */}
        <div className="space-y-2">
          {[
            { priority: "high", label: t.miniIllustrations.email.urgent },
            { priority: "medium", label: t.miniIllustrations.email.normal },
            { priority: "low", label: t.miniIllustrations.email.low },
          ].map((email, index) => (
            <div
              key={index}
              className={`border-l-4 ${
                email.priority === "high"
                  ? "border-red-500"
                  : email.priority === "medium"
                  ? "border-yellow-500"
                  : "border-green-500"
              } bg-accent/50 rounded-r px-3 py-2 animate-fade-in`}
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="text-xs font-medium">{email.label}</div>
              <div className="text-xs text-muted-foreground mt-1">
                {t.miniIllustrations.email.autoReplied}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MiniEmailIllustration;
